const EmptyLayout = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export default EmptyLayout;
